<template>
  <textarea
    :id="name"
    :value="modelValue"
    :name="name"
    :class="{ invalid: errors[name] !== undefined }"
    cols="30"
    rows="3"
    :data-test-base-text-area="name"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>

<script>
export default {
  name: 'BaseTextArea',

  props: {
    name: {
      type: String,
      default() {
        return 'base-text-area';
      }
    },
    modelValue: {
      type: String,
      default() {
        return null;
      }
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
